<template>
  <v-dialog
    v-model="getDialog"
    ref="dialog"
    max-width="464px"
    content-class="hidden-scroll"
    @click:outside="handleClickOutSite"
  >
    <v-card>
      <v-card-title>
        <span class="title-text" tabindex="0">
          {{ title || $t('bubble_chart.button_scatter_plot_setting') }}</span
        >
      </v-card-title>
      <v-card-text>
        <div class="scatter-plot">
          <div class="item vertical-axis">
            <div class="item-title">
              <span>{{ $t('bubble_chart.vertical_axis') }}</span>
            </div>
            <div class="item-content">
              <div class="topic">
                <v-select
                  :menu-props="{ contentClass: 'select-menu export-select z-index-high' }"
                  solo
                  fat
                  class="select-default list-menu--select select-item"
                  :items="topicData"
                  :label="$t('bubble_chart.label_select_unit')"
                  item-text="name"
                  item-value="id"
                  v-model="verticalAxis.topic"
                  @change="setVerticalAxisUnitList"
                ></v-select>
              </div>
              <div class="unit">
                <label class="unit-title">{{ $t('bubble_chart.unit_title') }}</label>
                <infinite-scroll
                  dropdownElementId="verticalAxis"
                  inputFieldElementId="verticalAxis"
                  searchInput="verticalAxis"
                  item-text="name"
                  item-value="key"
                  :items="verticalAxisUnitList"
                  :model="verticalAxis.unit"
                  :isCfp="true"
                  :label="$t('bubble_chart.label_select_unit')"
                  :key="verticalAxisUnitKey"
                  :isScatterNoData="true"
                  @updateMasterDb="updateVerticalAxisUnit"
                />
              </div>
            </div>
          </div>
          <div class="item horizontal-axis">
            <div class="item-title">
              <span>{{ $t('bubble_chart.horizontal_axis') }}</span>
            </div>
            <div class="item-content">
              <div class="topic">
                <v-select
                  :menu-props="{ contentClass: 'select-menu export-select z-index-high' }"
                  solo
                  fat
                  class="select-default list-menu--select select-item"
                  :items="topicData"
                  :label="$t('bubble_chart.label_select_unit')"
                  item-text="name"
                  item-value="id"
                  v-model="horizontalAxis.topic"
                  @change="setHorizontalAxisUnitList"
                ></v-select>
              </div>
              <div class="unit">
                <label class="unit-title">{{ $t('bubble_chart.unit_title') }}</label>
                <infinite-scroll
                  dropdownElementId="horizontalAxis"
                  inputFieldElementId="horizontalAxis"
                  searchInput="horizontalAxis"
                  item-text="name"
                  item-value="key"
                  typeList="unit"
                  :items="horizontalAxisUnitList"
                  :model="horizontalAxis.unit"
                  :isCfp="true"
                  :label="$t('bubble_chart.label_select_unit')"
                  :key="horizontalAxisUnitKey"
                  :isScatterNoData="true"
                  @updateMasterDb="updateHorizontalAxisUnit"
                />
              </div>
            </div>
          </div>
          <div class="item bubble-size">
            <div class="item-title">
              <span>{{ $t('bubble_chart.bubble_size') }}</span>
            </div>
            <div class="item-content">
              <div class="topic">
                <v-select
                  :menu-props="{ contentClass: 'select-menu export-select z-index-high' }"
                  solo
                  fat
                  class="select-default list-menu--select select-item"
                  :items="topicData"
                  :label="$t('bubble_chart.label_select_unit')"
                  item-text="name"
                  item-value="id"
                  v-model="bubbleSize.topic"
                  @change="setBubbleSizeUnitList"
                ></v-select>
              </div>
              <div class="unit">
                <label class="unit-title">{{ $t('bubble_chart.unit_title') }}</label>
                <infinite-scroll
                  dropdownElementId="bubbleSize"
                  inputFieldElementId="bubbleSize"
                  searchInput="bubbleSize"
                  item-text="name"
                  item-value="key"
                  typeList="unit"
                  :items="bubbleSizeUnitList"
                  :model="bubbleSize.unit"
                  :isCfp="true"
                  :label="$t('bubble_chart.label_select_unit')"
                  :key="bubbleSizeUnitKey"
                  :isScatterNoData="true"
                  @updateMasterDb="updateBubbleSizeUnit"
                />
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <common-button @action="close" :label="closeBtnLabel"></common-button>
        <common-button :buttonType="confirmBtnClass" @action="submit" :label="confirmText"></common-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InfiniteScroll from '@/components/pulldown/InfiniteScroll';
import CommonButton from '@/components/commonApp/ButtonCustom/NewButton';
import { getUnitByAxis } from '@/api/product';

export default {
  components: { InfiniteScroll, CommonButton },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: '',
    },
    confirmBtnClass: {
      type: String,
      default: 'colored',
    },
    selectedTab: {
      type: Number,
      default: 0,
    },
    currentYear: {
      type: Object,
      required: true,
    },
    axisConfigData: {
      type: Object,
    },
  },
  data() {
    return {
      topicData: [
        {
          name: this.$t('bubble_chart.option_product_quantity_scatter_plot_setting'),
          id: 1,
          value: 'product_quantity',
        },
        {
          name: this.$t('bubble_chart.option_discharge_volume_scatter_plot_setting'),
          id: 2,
          value: 'product_emission',
        },
        {
          name: this.$t('bubble_chart.option_unit_discharge_amount_scatter_plot_setting'),
          id: 3,
          value: 'declaration_unit_emission',
        },
        {
          name: this.$t('bubble_chart.option_annual_production_volume_scatter_plot_setting'),
          id: 4,
          value: 'annual_product',
        },
        {
          name: this.$t('bubble_chart.option_annual_output_scatter_plot_setting'),
          id: 5,
          value: 'annual_product_emission',
        },
        {
          name: this.$t('bubble_chart.option_product_amount'),
          id: 6,
          value: 'product_price',
        },
        {
          name: this.$t('bubble_chart.option_years_of_sale_scatter_plot_setting'),
          id: 7,
          value: 'annual_revenue',
        },
      ],
      verticalAxisUnitList: [],
      horizontalAxisUnitList: [],
      bubbleSizeUnitList: [],
      productQuantityList: [],
      annualProductList: [],
      productPriceList: [],
      annualRevenueList: [],
      emissionUnitList: [
        {
          key: 'TCO2',
          name: 't-CO2e',
        },
        {
          key: 'KgTCO2',
          name: 'kg-CO2e',
        },
      ],
      verticalAxis: {
        topic: 3,
        unit: null,
      },
      horizontalAxis: {
        topic: 1,
        unit: null,
      },
      bubbleSize: {
        topic: 2,
        unit: null,
      },
      verticalAxisUnitKey: 0,
      horizontalAxisUnitKey: 0,
      bubbleSizeUnitKey: 0,
      requestDataScatter: [],
      keyOption: {
        productQuantity: 'product_quantity',
        annualProduct: 'annual_product',
        productPrice: 'product_price',
        annualRevenue: 'annual_revenue',
      },
    };
  },
  async mounted() {
    await Promise.all([this.getListUnitProductQuantity(), this.getListUnitAnnualProduct(), this.getListUnitPrice(), this.getListUnitAnnualRevenue()])

    this.updateAxisData();
    this.submit();
  },
  computed: {
    getDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('update:dialog', value);
      },
    },
    closeBtnLabel() {
      if (this.cancelText) {
        return this.$t(this.cancelText);
      }
      return this.$t('popup.button_cancel');
    },
    isChangeProps() {
      return this.selectedTab;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      this.requestDataScatter = {
        verticalAxis: {
          topic: this.topicData.find((item) => item.id === this.verticalAxis.topic).value,
          unit: this.verticalAxisUnitList.find((item) => item?.key === this.verticalAxis.unit) || null,
        },
        horizontalAxis: {
          topic: this.topicData.find((item) => item.id === this.horizontalAxis.topic).value,
          unit: this.horizontalAxisUnitList.find((item) => item?.key === this.horizontalAxis.unit) || null,
        },
        bubbleSize: {
          topic: this.topicData.find((item) => item.id === this.bubbleSize.topic).value,
          unit: this.bubbleSizeUnitList.find((item) => item?.key === this.bubbleSize.unit) || null,
        },
      };

      this.$emit('submit', this.requestDataScatter);
    },

    handleClickOutSite() {
      this.close();
    },

    updateVerticalAxisUnit(newVal) {
      this.verticalAxis.unit = newVal;
    },

    updateHorizontalAxisUnit(newVal) {
      this.horizontalAxis.unit = newVal;
    },

    updateBubbleSizeUnit(newVal) {
      this.bubbleSize.unit = newVal;
    },

    setVerticalAxisUnitList(topicId) {
      this.verticalAxis.unit = null;
      this.verticalAxisUnitKey += 1;

      if (topicId === 1) {
        this.verticalAxisUnitList = this.productQuantityList;
      } else if (topicId === 4) {
        this.verticalAxisUnitList = this.annualProductList;
      } else if ([2, 3, 5].includes(topicId)) {
        this.verticalAxisUnitList = this.emissionUnitList;
      } else if (topicId === 6) {
        this.verticalAxisUnitList = this.productPriceList;
      } else if (topicId === 7) {
        this.verticalAxisUnitList = this.annualRevenueList;
      }

      const unitKey = this.axisConfigData.verticalAxis?.unit?.key
      const checkInclude = this.verticalAxisUnitList.map(item => item?.key).includes(unitKey)
      if (checkInclude) {
        this.verticalAxis.unit = unitKey;
      } else this.verticalAxis.unit = this.verticalAxisUnitList[0]?.key;
    },

    setHorizontalAxisUnitList(topicId) {
      this.horizontalAxis.unit = null;
      this.horizontalAxisUnitKey += 1;

      if (topicId === 1) {
        this.horizontalAxisUnitList = this.productQuantityList;
      } else if (topicId === 4) {
        this.horizontalAxisUnitList = this.annualProductList;
      } else if ([2, 3, 5].includes(topicId)) {
        this.horizontalAxisUnitList = this.emissionUnitList;
      } else if (topicId === 6) {
        this.horizontalAxisUnitList = this.productPriceList;
      } else if (topicId === 7) {
        this.horizontalAxisUnitList = this.annualRevenueList;
      }

      const unitKey = this.axisConfigData.horizontalAxis?.unit?.key
      const checkInclude = this.horizontalAxisUnitList.map(item => item?.key).includes(unitKey)
      if (checkInclude) {
        this.horizontalAxis.unit = unitKey;
      } else this.horizontalAxis.unit = this.horizontalAxisUnitList[0]?.key;
    },

    setBubbleSizeUnitList(topicId) {
      this.bubbleSize.unit = null;
      this.bubbleSizeUnitKey += 1;

      if (topicId === 1) {
        this.bubbleSizeUnitList = this.productQuantityList;
      } else if (topicId === 4) {
        this.bubbleSizeUnitList = this.annualProductList;
      } else if ([2, 3, 5].includes(topicId)) {
        this.bubbleSizeUnitList = this.emissionUnitList;
      } else if (topicId === 6) {
        this.bubbleSizeUnitList = this.productPriceList;
      } else if (topicId === 7) {
        this.bubbleSizeUnitList = this.annualRevenueList;
      }

      const unitKey = this.axisConfigData.bubbleSize?.unit?.key
      const checkInclude = this.bubbleSizeUnitList.map(item => item?.key).includes(unitKey)
      if (checkInclude) {
        this.bubbleSize.unit = unitKey;
      } else this.bubbleSize.unit = this.bubbleSizeUnitList[0]?.key;
    },

    async getListUnitProductQuantity() {
      try {
        const type = this.selectedTab;
        const listUnitProductQuantity = await getUnitByAxis({
          key: this.keyOption.productQuantity
        });

        this.productQuantityList = Object.keys(listUnitProductQuantity).map((item) => listUnitProductQuantity[item]);
      } catch (error) {
        console.warn(error);
      }
    },

    async getListUnitAnnualProduct() {
      try {
        const type = this.selectedTab;
        const listUnitAnnualProduct = await getUnitByAxis({
          key: this.keyOption.annualProduct
        });

        this.annualProductList = Object.keys(listUnitAnnualProduct).map((item) => listUnitAnnualProduct[item]);
      } catch (error) {
        console.warn(error);
      }
    },

    async getListUnitPrice() {
      try {
        const type = this.selectedTab;
        const listUnitPrice = await getUnitByAxis({
          key: this.keyOption.productPrice
        });

        this.productPriceList = Object.keys(listUnitPrice).map((item) => listUnitPrice[item]);
      } catch (error) {
        console.warn(error);
      }
    },

    async getListUnitAnnualRevenue() {
      try {
        const type = this.selectedTab;
        const listUnitAnnualRevenue = await getUnitByAxis({
          key: this.keyOption.annualRevenue
        });

        this.annualRevenueList = Object.keys(listUnitAnnualRevenue).map((item) => listUnitAnnualRevenue[item]);
      } catch (error) {
        console.warn(error);
      }
    },

    updateUnitLists() {
      this.setVerticalAxisUnitList(this.verticalAxis.topic);
      this.setHorizontalAxisUnitList(this.horizontalAxis.topic);
      this.setBubbleSizeUnitList(this.bubbleSize.topic);
    },

    updateAxisData() {
      const { verticalAxis, horizontalAxis, bubbleSize } = this.axisConfigData || {};
      const selectedVertical = this.topicData.find(
        (item) => item.value === verticalAxis?.topic,
      );
      const selectedHorizontal = this.topicData.find(
        (item) => item.value === horizontalAxis?.topic,
      );
      const selectedSize = this.topicData.find(
        (item) => item.value === bubbleSize?.topic,
      );

      this.verticalAxis.topic = selectedVertical?.id || 3;
      this.horizontalAxis.topic = selectedHorizontal?.id || 1;
      this.bubbleSize.topic = selectedSize?.id || 2;

      this.updateUnitLists()
    }
  },
  watch: {
    currentYear: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          await Promise.all([this.getListUnitProductQuantity(), this.getListUnitAnnualProduct(), this.getListUnitPrice(), this.getListUnitAnnualRevenue()])

          this.updateAxisData();
          this.submit();
        }
      },
      deep: true,
    },
    productQuantityList: 'updateUnitLists',
    productPriceList: 'updateUnitLists',
    annualProductList: 'updateUnitLists',
    annualRevenueList: 'updateUnitLists',
    dialog: {
      handler(newVal) {
        if (newVal) {
          this.updateAxisData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/components/popup/index.scss';

::v-deep {
  .v-card__title {
    height: 56px;
    display: flex;
    gap: 12px;
    padding: 16px !important;
    .title-text {
      color: $monoBlack;
      font-family: 'Source Han Sans';
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.03px;
    }
  }

  .v-card__text {
    line-height: 26px !important;
    letter-spacing: normal !important;
    font-size: 14px !important;
    font-weight: normal !important;
    padding: 0 !important;

    .scatter-plot {
      .item {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        position: relative;

        &:not(:last-child)::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 1px;
          background-color: $dividerBlack;
        }

        .item-title {
          font-weight: 500;
          letter-spacing: 0.03px;
          line-height: 26px;
        }

        .item-content {
          padding: 0 16px;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .topic {
            .v-input {
              .v-input__control {
                .v-input__slot {
                  background-color: #fff !important;
                  border: 1px solid #2a2a301a !important;
                  box-shadow: none !important;
                }
              }
            }
          }
          .unit {
            display: flex;
            gap: 8px;
            align-items: center;

            .unit-title {
              color: $monoDark;
              word-break: keep-all;
              font-size: 13px;
              font-weight: 400;
              letter-spacing: 0.05px;
            }

            .infinite-scroll {
              .input-field {
                border: 1px solid #2a2a301a !important;
                box-shadow: none !important;
              }
            }
          }
        }
        &.has-error {
          padding-bottom: 24px;
        }
      }
    }
  }

  .v-card__actions {
    display: flex;
    gap: 8px;
    width: 100%;
  }

  .hidden-scroll {
    overflow-y: unset;
  }
}
</style>
